import { configureStore } from '@reduxjs/toolkit';
import { getCurrentEnvName } from '../constants/envs';
import { rootReducer as reducer } from './reducers';

const env = getCurrentEnvName();
const devToolsEnabled = env === 'dev'; // DEV ONLY. postMessage script disabled there.


const Store = configureStore({
    reducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          // Ignore these action types
          ignoredActions: [],
          // Ignore these field paths in all actions
          ignoredActionPaths: ['payload.headers'],
          // Ignore these paths in the state
          ignoredPaths: [],
        },
      }),
    devTools: devToolsEnabled,
});

export const storeAppDispatch = Store.dispatch;
export default Store;
